module.exports = __webpack_public_path__ + "img/Energizing New Behavior.25343f1a.png";